import React from "react";
import "./assets/scss/App.scss";
import AppRouter from "./AppRouter";
import { RefreshState } from "./functions/index";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  if (performance.getEntriesByType("navigation")[0].type === "reload") RefreshState();

  return <AppRouter></AppRouter>;
}
export default App;